var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import getMessage from 'src/background/utils/i18n.utils';
import { addCaptionToLoading } from '@popup/multichain/actions/loading.actions';
import { goBack } from '@popup/multichain/actions/navigation.actions';
import { setTitleContainerProperties } from '@popup/multichain/actions/title-container.actions';
import { KeysUtils } from '@popup/steem/utils/keys.utils';
import { MultisigUtils } from '@popup/steem/utils/multisig.utils';
import { Screen } from '@reference-data/screen.enum';
import { KeychainKeyTypes, } from '@steempro/steem-keychain-commons';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import ButtonComponent, { ButtonType, } from 'src/common-ui/button/button.component';
import { InputType } from 'src/common-ui/input/input-type.enum';
import InputComponent from 'src/common-ui/input/input.component';
import { Separator } from 'src/common-ui/separator/separator.component';
const ConfirmationPage = ({ fields, message, afterConfirmAction, afterCancelAction, warningMessage, warningParams, skipWarningTranslation, title, skipTitleTranslation, activeAccount, method, goBack, setTitleContainerProperties, addCaptionToLoading, }) => {
    const [willUseMultisig, setWillUseMultisig] = useState();
    const [hasField] = useState(fields && fields.length !== 0);
    const [twoFABots, setTwoFABots] = useState({});
    useEffect(() => {
        setTitleContainerProperties({
            title: title !== null && title !== void 0 ? title : 'popup_html_confirm',
            skipTitleTranslation,
            isBackButtonEnabled: true,
            onBackAdditional: () => {
                if (afterCancelAction) {
                    afterCancelAction();
                }
            },
            onCloseAdditional: () => {
                if (afterCancelAction) {
                    afterCancelAction();
                }
            },
        });
        checkForMultsig();
    }, []);
    const checkForMultsig = () => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b;
        let useMultisig = false;
        switch (method) {
            case KeychainKeyTypes.active: {
                if (activeAccount.keys.active) {
                    useMultisig = KeysUtils.isUsingMultisig(activeAccount.keys.active, activeAccount.account, ((_a = activeAccount.keys.activePubkey) === null || _a === void 0 ? void 0 : _a.startsWith('@'))
                        ? activeAccount.keys.activePubkey.replace('@', '')
                        : activeAccount.account.name, method.toLowerCase());
                    setWillUseMultisig(useMultisig);
                    if (useMultisig) {
                        const accounts = yield MultisigUtils.get2FAAccounts(activeAccount.account, method);
                        accounts.forEach((acc) => setTwoFABots((old) => {
                            return Object.assign(Object.assign({}, old), { [acc]: '' });
                        }));
                    }
                }
                break;
            }
            case KeychainKeyTypes.posting: {
                if (activeAccount.keys.posting) {
                    useMultisig = KeysUtils.isUsingMultisig(activeAccount.keys.posting, activeAccount.account, ((_b = activeAccount.keys.postingPubkey) === null || _b === void 0 ? void 0 : _b.startsWith('@'))
                        ? activeAccount.keys.postingPubkey.replace('@', '')
                        : activeAccount.account.name, method.toLowerCase());
                    setWillUseMultisig(useMultisig);
                    if (useMultisig) {
                        const accounts = yield MultisigUtils.get2FAAccounts(activeAccount.account, method);
                        accounts.forEach((acc) => setTwoFABots((old) => {
                            return Object.assign(Object.assign({}, old), { [acc]: '' });
                        }));
                    }
                }
                break;
            }
        }
    });
    const handleClickOnConfirm = () => {
        let metadata;
        // AnalyticsUtils.sendRequestEvent(title);
        if (willUseMultisig) {
            addCaptionToLoading(twoFABots && Object.keys(twoFABots).length > 0
                ? 'multisig_transmitting_to_2fa'
                : 'multisig_transmitting_to_multisig');
            metadata = { twoFACodes: twoFABots };
        }
        afterConfirmAction({ metaData: metadata });
    };
    const handleClickOnCancel = () => __awaiter(void 0, void 0, void 0, function* () {
        if (afterCancelAction) {
            afterCancelAction();
        }
        goBack();
    });
    return (React.createElement("div", { className: "confirmation-page", "data-testid": `${Screen.CONFIRMATION_PAGE}-page` },
        React.createElement("div", { className: `confirmation-top ${twoFABots && Object.keys(twoFABots).length > 0 ? 'twofa' : ''}` },
            React.createElement("div", { className: "introduction", dangerouslySetInnerHTML: {
                    __html: message,
                } }),
            warningMessage && (React.createElement("div", { "data-testid": "warning-message", className: "warning-message" }, skipWarningTranslation
                ? warningMessage
                : getMessage(warningMessage, warningParams))),
            willUseMultisig && (React.createElement("div", { "data-testid": "use-multisig-message", className: "multisig-message" },
                React.createElement("img", { src: "/assets/images/multisig/logo.png", className: "logo" }),
                React.createElement("div", { className: "message" }, getMessage('multisig_disclaimer_message')))),
            hasField && (React.createElement("div", { className: "fields" }, fields.map((field, index) => {
                var _a;
                return (React.createElement(React.Fragment, { key: field.label },
                    React.createElement("div", { className: "field" },
                        React.createElement("div", { className: "label" }, getMessage(field.label)),
                        React.createElement("div", { className: `value ${(_a = field.valueClassName) !== null && _a !== void 0 ? _a : ''}` }, field.value)),
                    index !== fields.length - 1 && (React.createElement(Separator, { key: ` separator-${field.label}`, type: 'horizontal', fullSize: true }))));
            }))),
            twoFABots && Object.keys(twoFABots).length > 0 && (React.createElement("div", { className: "two-fa-codes-panel" }, Object.entries(twoFABots).map(([botName, code]) => (React.createElement(InputComponent, { key: `${botName}-2fa-code`, type: InputType.TEXT, value: code, onChange: (value) => {
                    setTwoFABots((old) => {
                        return Object.assign(Object.assign({}, old), { [botName]: value });
                    });
                }, label: getMessage('multisig_bot_two_fa_code', [
                    botName,
                ]), skipLabelTranslation: true })))))),
        React.createElement("div", { className: "bottom-panel" },
            React.createElement(ButtonComponent, { dataTestId: "dialog_cancel-button", label: 'dialog_cancel', onClick: handleClickOnCancel, type: ButtonType.ALTERNATIVE }),
            React.createElement(ButtonComponent, { dataTestId: "dialog_confirm-button", label: 'popup_html_confirm', onClick: ($event) => {
                    $event.target.disabled = true;
                    handleClickOnConfirm();
                }, type: ButtonType.IMPORTANT }))));
};
const mapStateToProps = (state) => {
    return {
        message: state.navigation.stack[0].params.message,
        fields: state.navigation.stack[0].params.fields,
        warningMessage: state.navigation.stack[0].params.warningMessage,
        warningParams: state.navigation.stack[0].params.warningParams,
        skipWarningTranslation: state.navigation.stack[0].params.skipWarningTranslation,
        afterConfirmAction: state.navigation.stack[0].params.afterConfirmAction,
        afterCancelAction: state.navigation.stack[0].params.afterCancelAction,
        title: state.navigation.stack[0].params.title,
        skipTitleTranslation: state.navigation.stack[0].params.skipTitleTranslation,
        method: state.navigation.stack[0].params.method,
        activeAccount: state.steem.activeAccount,
    };
};
const connector = connect(mapStateToProps, {
    goBack,
    setTitleContainerProperties,
    addCaptionToLoading,
});
export const ConfirmationPageComponent = connector(ConfirmationPage);
